// ==============================|| OVERRIDES - CARD HEADER ||============================== //

export default function CardHeader(theme) {
  return {
    MuiCardHeader: {
      variants: [
        {
          props: { variant: 'landing-card-header' },
          style: {
           
            minHeight: '65px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            '& .MuiCardHeader-content': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'visible'
            },
            '& .MuiCardHeader-title': {
              fontWeight: 600,
              fontSize: '0.95rem',
              lineHeight: 1.2,
              textAlign: 'center',
              color: '#1a1a1a',
              whiteSpace: 'normal',
              wordBreak: 'break-word'
            }
          }
        }
      ],
      styleOverrides: {
        root: {
          color: theme.palette.text.dark,
          padding: '24px'
        },
        title: {
          fontSize: '1.125rem',
          fontWeight: 600
        }
      }
    }
  };
}
